import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Changepassword from '../components/Changepassword';

const Forgoten = () => {
    return (
        <div>
            <Header />
            <Changepassword />
            <Footer />
        </div>
    );
};

export default Forgoten;
